var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey)),function(item,index){return _c('span',{key:index,class:`${_vm.textColor}--text`},[(item==true)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-check-circle")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-close-circle")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }